"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryTintColor = exports.primaryTextColor = void 0;
// Brand-purple foreground (text, icons, outlines, spinners) that stays legible
// in dark mode: primary.main in light, primary.light in dark (dark primary.main
// is near-black). Use as an sx value: sx={{ color: primaryTextColor }}.
// For plain Typography prefer color="primary.main" - the theme swaps it already.
var primaryTextColor = function (theme) {
    return theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.main;
};
exports.primaryTextColor = primaryTextColor;
// Soft brand tint for selected/highlighted surfaces, paired with
// primaryTextColor text: primary.light in light, accent.light in dark
// (dark primary.light is near-white, which would hide primaryTextColor).
// Use as an sx value: sx={{ backgroundColor: primaryTintColor }}.
var primaryTintColor = function (theme) {
    return theme.palette.mode === "dark"
        ? theme.palette.accent.light
        : theme.palette.primary.light;
};
exports.primaryTintColor = primaryTintColor;
//# sourceMappingURL=colors.js.map